import {InsuranceType} from '../sale';
import {CategoryCode} from './category';
import {Duration} from './duration';

export enum RiderType {
  CHILD = 'CHILD',
  CANCER = 'CANCER',
  CRITICAL_ILLNESS = 'CRITICAL_ILLNESS',
  DISABILITY = 'DISABILITY',
  ACCIDENTAL_DEATH = 'ACCIDENTAL_DEATH',
  GUARANTEED_INSURABILITY = 'GUARANTEED_INSURABILITY',
  WAIVER_OF_PREMIUM = 'WAIVER_OF_PREMIUM',
}

export interface Rider {
  type: RiderType;
  coverage: number;
  duration?: number;
  price: number;
  annualPrice: number;
}

export interface PriceBreakdown {
  basePremium: number;
  policyFee: number;
  surchargeAmount: number;
  baseAnnualPremium: number;
  policyAnnualFee: number;
  surchargeAnnualAmount: number;
  isBaseInsurance: boolean;
}

export interface PersonInsurance {
  priceBreakdown: PriceBreakdown;
  coverage: number;
  duration: Duration;
  price: number;
  annualPrice: number;
  type: InsuranceType;
  categoryCode?: CategoryCode;
  renewalPrices?: number[];
  riders?: Rider[];
}

export type PersonInsuranceType = 'WHOLE' | 'TERM';

export function arePersonInsurancesEqual(insurance1: PersonInsurance, insurance2: PersonInsurance): boolean {
  return (
    insurance1.coverage === insurance2.coverage &&
    insurance1.duration === insurance2.duration &&
    insurance1.price === insurance2.price &&
    insurance1.annualPrice === insurance2.annualPrice &&
    insurance1.type === insurance2.type &&
    insurance1.categoryCode === insurance2.categoryCode &&
    areRidersEqual(insurance1.riders, insurance2.riders)
  );
}

function areRidersEqual(riders1?: Rider[], riders2?: Rider[]): boolean {
  if (!riders1 && !riders2) return true;
  if (!riders1 && riders2?.length === 0) return true;
  if (riders1?.length === 0 && !riders2) return true;
  if (!riders1 || !riders2) return false;
  if (riders1.length !== riders2.length) return false;

  return riders1.every((rider1) =>
    riders2.some(
      (rider2) =>
        rider1.type === rider2.type && rider1.coverage === rider2.coverage && rider1.price === rider2.price,
    ),
  );
}
